import { useState, useCallback } from 'react';
import {
  getEdcUrl,
  getEdcUrlSingle,
  getCreateNewsUpdate
} from '../api.js';
import { TOKEN } from '../constants.js';
import { log as serverLog, error as serverError } from '../utils/serverLogger.js';

const useDataManagement = () => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [countryCode, setCountryCode] = useState('');

  const getData = useCallback(async (apiName, countryCode, languageCode, locationId, maxNumberOfRows) => {
    setCountryCode(countryCode);
    const url = getEdcUrl(
      apiName,
      countryCode,
      languageCode,
      locationId,
      (currentPage - 1) * maxNumberOfRows,
      maxNumberOfRows,
      undefined,
      false
    );

    try {
      const response = await fetch(url);
      const data = await response.json();
      setCount(data.count || -1);
      setRows(data.rows);
    } catch (error) {
      console.error('Error fetching data:', error);
      setCount(-1);
      setRows([]);
    }
  }, [currentPage]);

  const handleSelect = async (apiName, countryCode, id) => {
    const url = getEdcUrlSingle(apiName, countryCode, id);
    try {
      const response = await fetch(url, {
        method: "PUT",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "token": TOKEN,
          "Content-Type": 'application/x-www-form-urlencoded',
        },
        body: {}
      });
      return response.status === 200;
    } catch (error) {
      console.error('Error selecting item:', error);
      return false;
    }
  };

  const handleUpdate = async (apiName, countryCode, id, title = "", title_ko = "") => {
    if (!title_ko) {
      console.error("[update] Korean title must be filled");
      serverError("[update] Korean title must be filled");
      return false;
    }

    const url = getEdcUrlSingle(apiName, countryCode, id);
    const body = { title, title_ko };
    console.log("[update] Start", { apiName, countryCode, id, url, body });
    serverLog("[update] Start", { apiName, countryCode, id, url, body });

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "token": TOKEN,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify(body)
      });

      const responseText = await response.text();
      console.log("[update] Response", { status: response.status, statusText: response.statusText, body: responseText });
      serverLog("[update] Response", { status: response.status, statusText: response.statusText, body: responseText });

      if (response.status === 200) {
        setRows(prevRows =>
          prevRows.map(item =>
            item.id === id
              ? { ...item, title, title_ko }
              : item
          )
        );
        setCount(prev => prev - 1);
        console.log("[update] Success – local state updated");
        serverLog("[update] Success – local state updated");
        return true;
      }

      console.error("[update] Failed – non-200 status", { status: response.status, body: responseText });
      serverError("[update] Failed – non-200 status", { status: response.status, body: responseText });
      return false;
    } catch (error) {
      console.error("[update] Error (network or exception):", error.message, error);
      serverError("[update] Error (network or exception)", { message: error.message });
      return false;
    }
  };

  const handleShare = async (locationId, source, title, description, link) => {
    console.log(countryCode)
    if (countryCode === 'au') {
      locationId = 201;
    } else if (countryCode === 'ca') {
      locationId = 301;
    }
    if (!title) {
      console.error("Title must be filled");
      return false;
    }

    try {
      const url = getCreateNewsUpdate();
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "token": TOKEN,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          areaId: locationId,
          source,
          title,
          description,
          link
        })
      });

      return response.status === 200;
    } catch (error) {
      console.error('Error sharing news:', error);
      return false;
    }
  };

  const handleDelete = async (apiName, countryCode, id) => {
    try {
      const url = getEdcUrlSingle(apiName, countryCode, id);
      const response = await fetch(url, {
        method: "DELETE",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "token": TOKEN,
          "Content-Type": 'application/x-www-form-urlencoded',
        },
        body: {}
      });

      if (response.status === 200) {
        setRows(prevRows => prevRows.filter(item => item.id !== id));
        setCount(prev => prev - 1);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error deleting item:', error);
      return false;
    }
  };

  return {
    rows,
    count,
    setCount,
    currentPage,
    setCurrentPage,
    countryCode,
    setCountryCode,
    getData,
    handleSelect,
    handleUpdate,
    handleShare,
    handleDelete,
  };
};

export default useDataManagement; 